import React, { useEffect, useRef, useState } from "react";
import { addScholarship, getColleges, getCourseCategories, getCourses, getUniversities } from "../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../utils/HttpClientXml";
import moment from "moment";
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

const AddScholarship = () => {


  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false);

  const initialValues = {
    schemeName: "",
    shortDescription: "",
    longDescription: "",
    eligibilityCriteria: "",
    benefits: ""
  }

  const [formData, setFormData] = useState(initialValues)

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data.filter(item => item.categoryId === categoryId));
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, brochure: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if(!formData?.schemeName) return toast.error("Scheme Name should not be empty");
    if(!formData?.shortDescription) return toast.error("Please provide a short description");
  
    console.log("NHX156", formData);
    // return

    try {
      setCreateLoading(true);
      const res = await addScholarship(formData);
      console.log("Scholarship Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setCreateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Scholarship.");
      console.error("Error adding Scholarship:", error);
      setCreateLoading(false);
    }
  };

  useEffect(() => {
    // fetchUniversities()
    // fetchColleges()
    // fetchCourseCategories()
  }, [])

  // useEffect(() => {
  //   fetchCourses(formData.categoryId)
  // }, [formData.categoryId])

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Add Scholarship
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="row d-flex justify-content-center">

                <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Scheme Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData?.schemeName}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        schemeName: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter Scholarship Scheme Name"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Short Description<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData?.shortDescription}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        shortDescription: e?.target?.value,
                      }));
                    }}
                    placeholder="Short Description"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="longDescription">
                    Long Description
                  </label>
                  <ReactQuill
                    modules={modules}
                    theme="snow"
                    value={formData?.longDescription || ""}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        longDescription: value,
                      }));
                    }}
                    placeholder="Enter Long Description"
                    style={{
                      height: "150px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                      fontSize: "1rem"
                    }}
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Eligibility Criteria
                  </label>
                  {/* <textarea
                    style={{ resize: "none" }}
                    type="text"
                    id="name"
                    className="form-control"
                    value={formData?.eligibilityCriteria}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        eligibilityCriteria: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter Eligibility Criteria"
                  /> */}

                  <ReactQuill
                    modules={modules}
                    theme="snow"
                    value={formData?.eligibilityCriteria || ""}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        eligibilityCriteria: value,
                      }));
                    }}
                    placeholder="Enter Eligibility Criteria"
                    style={{
                      height: "150px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                      fontSize: "1rem"
                    }}
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="name">
                    Benefits
                  </label>
                  {/* <textarea
                    style={{ resize: "none" }}
                    type="text"
                    id="name"
                    className="form-control"
                    value={formData?.benefits}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        benefits: e?.target?.value,
                      }));
                    }}
                    placeholder="Enter benefits"
                  /> */}
                  <ReactQuill
                    modules={modules}
                    theme="snow"
                    value={formData?.benefits || ""}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        benefits: value,
                      }));
                    }}
                    placeholder="Enter benefits"
                    style={{
                      height: "150px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                      fontSize: "1rem"
                    }}
                  />
                </div>



               
              </div>
              
              <div className=" d-flex justify-content-center">
                <button
                  disabled={createLoading}
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                >
                  {createLoading
                    ? "Saving data..."
                    : "Add Scholarship"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddScholarship;
